import axios from "axios";
import { clearAuthData, getToken, isLoggedIn } from "./storageService";

const api = axios.create({
  baseURL: "https://web.nutrillion.one/",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});


api.interceptors.response.use(
  (response) => {
    if (response.data?.message === "Token expired" || 
        response.data?.status === 401) {
      clearAuthData();
      window.location.href = '/login';
      return Promise.reject(new Error('Token expired'));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      clearAuthData();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const POST_OTP = "/api/auth/send_otp";
export const VERIFY_OTP = "/api/auth/otp_verify";
export const POST_APPOINTMENT = "/api/user_appointments/create";
export const GET_FAQ = "/api/web/faq_get?sortby=createdAt&order=asc";
export const GET_FAQS = "/api/web/faq_get";
export const GET_CERTIFICATES = "/api/web/certificate_get";
export const GET_TESTIMONIALS = "/api/web/testimonial_get?sortby=createdAt&order=asc";
export const GET_TESTIMONIAL = "/api/web/testimonial_get";
export const GET_PRIVACY_POLICY = "/api/web/static_get";
export const GET_INSTRUCTORS = "/api/web/listInstructors";
export const GET_ALL_COURSES = "/api/web/ListAllCourses";
export const GET_COURSE_BY_SLUG = "/api/web/course";
export const GET_SEO_BY_URL = "/admin/api/seo/page/url";
export const GET_APPOINTMENTS = "/api/appointments/user/get";
export const GET_MY_PURCHASES = "/purchase/my-purchases";
export const APPOINTMENT_INQUIRY = "/api/appointments/inquiry";
export const POST_POPUP_INQUIRY = "/api/web/popup-inquiry";
export const GET_PROFILE_STEP_DETAILS = "/api/users/profile/step-details";
export const UPDATE_PROFILE_STEP = "/api/users/profile/update-step";
export const BOOK_CONSULTATION = "/api/consultation/book";
export const VERIFY_CONSULTATION_PAYMENT = "/api/consultation/verify-payment";
export const GET_TEAM = "/api/web/team_get";
export const GET_PROGRAMS = "/programs/get";
export const CREATE_ORDER = "/purchase/create-order";
export const VERIFY_PAYMENT = "/purchase/verify-payment";
export const GET_DIET_PLAN_DASHBOARD = "/api/users/diet-plan-dashboard";
export const SEND_OTP_UNLOCK_COURSE = "/api/auth/send_otp_unlock_course";
export const VERIFY_OTP_UNLOCK_COURSE = "/api/auth/otp_verify_unlock_course";
export const CREATE_COURSE_ORDER = "/api/courses/create-order";
export const VERIFY_COURSE_PAYMENT = "/api/courses/verify-payment";
export const GET_MY_PURCHASES_WITH_PROGRAMS = "/purchase/my-purchases-with-programs";
export const GET_WEB_DASHBOARD = "/api/users/web-dashboard";
export const GET_APPOINTMENT_DETAILS = "/api/appointments/appointment_deatails";
export const CREATE_FOLLOW_UP = "/api/appointments/follow_up_create";
export const GET_ALL_MY_COURSES = "/api/courses/my-courses";
export const GET_MY_COURSE_BY_SLUG = "/api/courses/my-courses";
export const UPDATE_VIDEO_PROGRESS = "/api/courses/video-progress/update";
export const GET_ASSESSMENT_START = "/api/assessments";
export const SUBMIT_ASSESSMENT_ANSWER = "/api/assessments/attempt";
export const SUBMIT_ASSESSMENT_FINAL = "/api/assessments/attempt";
export const GET_MY_RESOURCES = "/api/courses/my-resources";
export const GET_MY_RESOURCES_LIBRARY = "/api/courses/my-resources-library";
export const GET_CERTIFICATE_LIST = "/api/users/certificatelist";
export const VERIFY_CERTIFICATE = "/api/web/verify";
export const GET_NOTIFICATIONS = "/api/notifications";
export const GET_UNREAD_NOTIFICATIONS = "/api/notifications/unread";
export const GET_UNREAD_COUNT = "/api/notifications/unread-count";
export const MARK_NOTIFICATION_READ = "/api/notifications/read";
export const MARK_ALL_NOTIFICATIONS_READ = "/api/notifications/read-all";
export const VALIDATE_COUPON = "/api/coupons/validate";
export const GET_SLIDERS = "/api/web/slider_get";
export const GET_FINAL_ASSESSMENT = "/api/courses/my-assessment-final";

export const sendOtp = async (phone, type) => {
  try {
    const response = await api.post(POST_OTP, {
      phone: phone,
      type: type,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyOtp = async (phone, otp) => {
  try {
    const response = await api.post(VERIFY_OTP, {
      phone: phone,
      otp: otp,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAppointment = async (appointmentData) => {
  try {
    const response = await api.post(POST_APPOINTMENT, appointmentData);
    console.log("Nivedita from api:-", response.data)
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchBlogs = async () => {
  try {
    const response = await fetch("https://web.nutrillion.one/api/web/blog_get?sortby=createdAt&order=asc");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    return { status: false, data: [] };
  }
};

export const fetchCaseStudies = async () => {
  try {
    const response = await fetch("https://web.nutrillion.one/api/web/case_study_get?sortby=createdAt&order=asc");
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error("API Fetch Error:", error);
    return { status: false, data: [] };
  }
};

export const getFAQ = async () => {
  try {
    const response = await api.get(GET_FAQ);
    return response.data;
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return { status: false, message: "Failed to fetch FAQs", error: error.message };
  }
};
export const getFAQS = async (type = null) => {
  try {
    const url = type ? `${GET_FAQS}?type=${type}` : GET_FAQS;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return { status: false, message: "Failed to fetch FAQs", error: error.message };
  }
};
export const getCertificates = async () => {
  try {
    const response = await api.get(GET_CERTIFICATES);
    return response.data;
  } catch (error) {
    console.error("Error fetching Certificates:", error);
    return { status: false, message: "Failed to fetch Certificates", error: error.message };
  }
};

export const getTestimonials = async () => {
  try {
    const response = await api.get(GET_TESTIMONIALS);
    return response.data;
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    return { status: false, message: "Failed to fetch testimonials", error: error.message };
  }
};

export const getTestimonial = async (type = null) => {
  try {
    const url = type ? `${GET_TESTIMONIAL}?type=${type}` : GET_TESTIMONIAL;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    return { status: false, message: "Failed to fetch testimonials", error: error.message };
  }
};

export const getPrivacyPolicy = async () => {
  try {
    const response = await api.get(GET_PRIVACY_POLICY);
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    return { status: false, message: "Failed to fetch privacy policy", error: error.message };
  }
};

export const getInstructors = async () => {
  try {
    const response = await api.get(GET_INSTRUCTORS);
    return response.data;
  } catch (error) {
    console.error("Error fetching instructors:", error);
    return { status: false, message: "Failed to fetch instructors", error: error.message };
  }
};
export const getAllCourses = async () => {
  try {
    const response = await api.get(GET_ALL_COURSES);
    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    return { success: false, message: "Failed to fetch courses", error: error.message };
  }
};
export const getCourseBySlug = async (slug) => {
  try {
    const response = await api.get(`${GET_COURSE_BY_SLUG}/${slug}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching course:", error);
    return { success: false, message: "Failed to fetch course", error: error.message };
  }
};

export const getSeoByUrl = async (url) => {
  try {
    const response = await api.get(`${GET_SEO_BY_URL}/${url}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching SEO metadata:", error);
    return { status: false, message: "Failed to fetch SEO metadata", error: error.message };
  }
};

export const getAppointments = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`${GET_APPOINTMENTS}?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Get Appointments Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });

    const customError = new Error(error.response?.data?.message || "Failed to fetch appointments");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const getMyPurchases = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`${GET_MY_PURCHASES}?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Get My Purchases Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      page: page,
      limit: limit
    });

    const customError = new Error(error.response?.data?.message || "Failed to fetch purchases");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const appointmentInquiry = async (inquiryData) => {
  try {
    const response = await api.post(APPOINTMENT_INQUIRY, inquiryData);
    return response.data;
  } catch (error) {
    console.error("Appointment Inquiry Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      inquiryData: inquiryData
    });

    const customError = new Error(error.response?.data?.message || "Failed to submit appointment inquiry");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const createPopupInquiry = async (inquiryData) => {
  try {
    const response = await api.post(POST_POPUP_INQUIRY, inquiryData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProfileStepDetails = async () => {

  try {
    const response = await api.get(GET_PROFILE_STEP_DETAILS);
    return response.data;
  } catch (error) {
    console.error("Error fetching profile step details:", error);
    return {
      status: false,
      message: "Failed to fetch profile step details",
      error: error.message,
    };
  }
};
// export const updateProfileStep = async (step, data) => {
//   try {
//     const formData = new FormData();
//     formData.append("step", step);

//     Object.keys(data).forEach((key) => {
//       if (data[key] !== null && data[key] !== undefined) {
//         if (key === "profilePicture" && data[key] instanceof File) {
//           formData.append("profilePicture", data[key]);
//         }
//         else if (key !== "profilePicture") {
//           formData.append(key, data[key]);
//         }
//       }
//     });
//     const response = await api.post(UPDATE_PROFILE_STEP, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error(`Error updating ${step} step:`, {
//       message: error.message,
//       status: error.response?.status,
//       data: error.response?.data
//     });
//     const customError = new Error(
//       error.response?.data?.message || `Failed to update ${step} information`
//     );
//     customError.response = error.response;
//     customError.status = error.response?.status;
//     throw customError;
//   }
// };


export const updateProfileStep = async (step, data) => {
  try {
    if (data instanceof FormData) {
      data.append("step", step);
      const response = await api.post(UPDATE_PROFILE_STEP, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    }

    const formData = new FormData();
    formData.append("step", step);

    Object.keys(data).forEach((key) => {
      if (data[key] !== null && data[key] !== undefined) {
        if (key === "profilePicture" && data[key] instanceof File) {
          formData.append("profilePicture", data[key]);
        } else if (key !== "profilePicture") {
          formData.append(key, data[key]);
        }
      }
    });

    const response = await api.post(UPDATE_PROFILE_STEP, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating ${step} step:`, {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    const customError = new Error(
      error.response?.data?.message || `Failed to update ${step} information`
    );
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const bookConsultation = async (consultationData) => {
  try {
    const response = await api.post(BOOK_CONSULTATION, consultationData);
    return response.data;
  } catch (error) {
    console.error("Book Consultation Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    const customError = new Error(error.response?.data?.message || "Failed to book consultation");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const verifyConsultationPayment = async (paymentData) => {
  try {
    const response = await api.post(VERIFY_CONSULTATION_PAYMENT, paymentData);
    return response.data;
  } catch (error) {
    console.error("Payment Verification Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    const customError = new Error(error.response?.data?.message || "Failed to verify payment");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};


export const getTeamMembers = async () => {
  try {
    const response = await api.get(GET_TEAM);
    return response.data;
  } catch (error) {
    console.error("Error fetching team members:", error);
    return { status: false, message: "Failed to fetch team members", error: error.message };
  }
};

export const getPrograms = async () => {
  try {
    const response = await api.get(GET_PROGRAMS);
    return response.data;
  } catch (error) {
    console.error("Error fetching programs:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to fetch programs",
      error: error.message
    };
  }
};

export const createOrder = async (orderData) => {
  try {
    const response = await api.post(CREATE_ORDER, orderData);
    return response.data;
  } catch (error) {
    console.error("Create Order Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      orderData: orderData
    });

    const customError = new Error(error.response?.data?.message || "Failed to create order");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const verifyPayment = async (paymentData) => {
  try {
    const response = await api.post(VERIFY_PAYMENT, paymentData);
    return response.data;
  } catch (error) {
    console.error("Payment Verification Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      paymentData: paymentData
    });

    const customError = new Error(error.response?.data?.message || "Failed to verify payment");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const getDietPlanDashboard = async () => {
  try {
    const response = await api.get(GET_DIET_PLAN_DASHBOARD);
    return response.data;
  } catch (error) {
    console.error("Error fetching diet plan dashboard:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });

    const customError = new Error(error.response?.data?.message || "Failed to fetch diet plan dashboard");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const sendOtpUnlockCourse = async (phone, course_name) => {
  try {
    const response = await api.post(SEND_OTP_UNLOCK_COURSE, {
      phone: phone,
      course_name: course_name,
    });
    return response.data;
  } catch (error) {
    console.error("Send OTP Unlock Course Error:", error);
    throw error;
  }
};

export const verifyOtpUnlockCourse = async (phone, otp) => {
  try {
    const response = await api.post(VERIFY_OTP_UNLOCK_COURSE, {
      phone: phone,
      otp: otp,
    });
    return response.data;
  } catch (error) {
    console.error("Verify OTP Unlock Course Error:", error);
    throw error;
  }
};

export const createCourseOrder = async (orderData) => {
  try {
    const response = await api.post(CREATE_COURSE_ORDER, orderData);
    return response.data;
  } catch (error) {
    console.error("Create Course Order Error:", error);
    throw error;
  }
};

export const verifyCoursePayment = async (paymentData) => {
  try {
    const response = await api.post(VERIFY_COURSE_PAYMENT, paymentData);
    return response.data;
  } catch (error) {
    console.error("Verify Course Payment Error:", error);
    throw error;
  }
};

export const getMyPurchasesWithPrograms = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`${GET_MY_PURCHASES_WITH_PROGRAMS}?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Get My Purchases With Programs Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      page: page,
      limit: limit
    });

    const customError = new Error(error.response?.data?.message || "Failed to fetch purchases with programs");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};
export const getWebDashboard = async () => {
  try {
    const response = await api.get(GET_WEB_DASHBOARD);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard:", error);
    // Error will be handled by interceptor
    throw error;
  }
};

export const getAppointmentDetails = async (appointmentToken) => {
  try {

    const response = await api.get(`${GET_APPOINTMENT_DETAILS}`, {
      params: {
        id: appointmentToken
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching appointment details:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    const customError = new Error(error.response?.data?.message || "Failed to fetch appointment details");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const createFollowUp = async (followUpData) => {
  try {
    const response = await api.post(CREATE_FOLLOW_UP, followUpData);
    return response.data;
  } catch (error) {
    console.error("Create Follow Up Error:", error);
    throw error;
  }
};

export const getAllMyCourses = async () => {
  try {
    const response = await api.get(GET_ALL_MY_COURSES);
    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    return { success: false, message: "Failed to fetch courses", error: error.message };
  }
};

export const getMyCourseBySlug = async (slug) => {
  try {
    const response = await api.get(`${GET_MY_COURSE_BY_SLUG}/${slug}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching course:", error);
    return { success: false, message: "Failed to fetch course", error: error.message };
  }
};

export const updateVideoProgress = async (videoId, progressData) => {
  try {
    const response = await api.post(UPDATE_VIDEO_PROGRESS, {
      video_id: videoId,
      ...progressData
    });
    return response.data;
  } catch (error) {
    console.error("Update Video Progress Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      videoId: videoId,
      progressData: progressData
    });

    const customError = new Error(error.response?.data?.message || "Failed to update video progress");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const startAssessment = async (assessmentId) => {
  try {
    const response = await api.get(`${GET_ASSESSMENT_START}/${assessmentId}/start`);
    return response.data;
  } catch (error) {
    console.error("Start Assessment Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      assessmentId: assessmentId
    });

    const customError = new Error(error.response?.data?.message || "Failed to start assessment");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const submitAnswer = async (attemptId, questionId, answer, timeSpent = 0, markForReview = false) => {
  try {
    const response = await api.post(`${SUBMIT_ASSESSMENT_ANSWER}/${attemptId}/answer`, {
      question_id: questionId,
      answer: answer,
      time_spent: timeSpent,
      mark_for_review: markForReview
    });
    return response.data;
  } catch (error) {
    console.error("Submit Answer Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      attemptId: attemptId,
      questionId: questionId,
      answer: answer
    });

    const customError = new Error(error.response?.data?.message || "Failed to submit answer");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const submitAssessmentFinal = async (attemptId) => {
  try {
    const response = await api.post(`${SUBMIT_ASSESSMENT_FINAL}/${attemptId}/submit`);
    return response.data;
  } catch (error) {
    console.error("Final Submit Assessment Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      attemptId: attemptId
    });

    const customError = new Error(error.response?.data?.message || "Failed to submit assessment");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

export const getMyResources = async () => {
  try {
    const response = await api.get(GET_MY_RESOURCES);
    return response.data;
  } catch (error) {
    console.error("Error fetching my resources:", error);
    return { success: false, message: "Failed to fetch my resources", error: error.message };
  }
};
export const getMyResourcesLibrary = async (params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${GET_MY_RESOURCES_LIBRARY}?${queryString}` : GET_MY_RESOURCES_LIBRARY;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching resources library:", error);
    throw error;
  }
};

export const getCertificateList = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`${GET_CERTIFICATE_LIST}?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Get Certificate List Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      page: page,
      limit: limit
    });

    const customError = new Error(error.response?.data?.message || "Failed to fetch certificate list");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};
export const verifyCertificate = async (verification_no, name) => {
  try {
    const response = await api.get(VERIFY_CERTIFICATE, {
      params: {
        verification_no,
        name,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Verify Certificate Error:", error);

    throw new Error(
      error.response?.data?.message || "Failed to verify certificate"
    );
  }
};
export const getNotifications = async (status = null) => {
  try {
    let url = GET_NOTIFICATIONS;
    if (status !== null) {
      url = `${GET_NOTIFICATIONS}?status=${status}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return { 
      success: false, 
      message: "Failed to fetch notifications", 
      error: error.message 
    };
  }
};
export const getUnreadNotifications = async () => {
  try {
    const response = await api.get(GET_UNREAD_NOTIFICATIONS);
    return response.data;
  } catch (error) {
    console.error("Error fetching unread notifications:", error);
    return { 
      success: false, 
      message: "Failed to fetch unread notifications", 
      error: error.message 
    };
  }
};
export const getUnreadCount = async () => {
  try {
    const response = await api.get(GET_UNREAD_COUNT);
    return response.data;
  } catch (error) {
    console.error("Error fetching unread count:", error);
    return { 
      success: false, 
      message: "Failed to fetch unread count", 
      error: error.message,
      data: { count: 0 }
    };
  }
};
export const markNotificationAsRead = async (notificationId) => {
  try {
    // The correct endpoint should be /api/notifications/{id}/read
    // But you have MARK_NOTIFICATION_READ = "/api/notifications/read"
    // So it's trying to hit /api/notifications/read/1/read which doesn't exist
    
    // Fix: Use the correct URL pattern
    const response = await api.patch(`/api/notifications/${notificationId}/read`);
    return response.data;
  } catch (error) {
    console.error("Mark Notification as Read Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      notificationId: notificationId
    });
    
    const customError = new Error(error.response?.data?.message || "Failed to mark notification as read");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};

// Mark all notifications as read
export const markAllNotificationsAsRead = async () => {
  try {
    const response = await api.patch(MARK_ALL_NOTIFICATIONS_READ);
    return response.data;
  } catch (error) {
    console.error("Mark All Notifications as Read Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    
    const customError = new Error(error.response?.data?.message || "Failed to mark all notifications as read");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};
export const validateCoupon = async (couponData) => {
  try {
    const response = await api.post(VALIDATE_COUPON, couponData);
    return response.data;
  } catch (error) {
    console.error("Validate Coupon Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      couponData: couponData
    });

    const customError = new Error(error.response?.data?.message || "Failed to validate coupon");
    customError.response = error.response;
    customError.status = error.response?.status;
    customError.data = error.response?.data;
    throw customError;
  }
};
export const getSliders = async () => {
    try {
        const response = await api.get(GET_SLIDERS);
        return response.data;
    } catch (error) {
        console.error("Get Sliders Error:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data
        });

        const customError = new Error(error.response?.data?.message || "Failed to fetch sliders");
        customError.response = error.response;
        customError.status = error.response?.status;
        throw customError;
    }
};

export const getFinalAssessment = async (courseSlug) => {
  try {
    const response = await api.get(`${GET_FINAL_ASSESSMENT}/${courseSlug}`);
    return response.data;
  } catch (error) {
    console.error("Get Final Assessment Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      courseSlug: courseSlug
    });

    const customError = new Error(error.response?.data?.message || "Failed to fetch final assessment");
    customError.response = error.response;
    customError.status = error.response?.status;
    throw customError;
  }
};